import { useRoutes } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { ThemeProvider } from "@material-ui/core";
import "./i18n";
import GlobalStyles from "./components/GlobalStyles";
import RTL from "./components/RTL";
import Login from "./pages/authentication/Login";
import useAuth from "./hooks/useAuth";
import useScrollReset from "./hooks/useScrollReset";
import useSettings from "./hooks/useSettings";
import routes from "./routes";
import { createDashboardTheme } from "./theme";

const App = () => {
  const content = useRoutes(routes);
  const { settings } = useSettings();
  const auth = useAuth();
  useScrollReset();

  const theme = createDashboardTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    roundedCorners: settings.roundedCorners,
    theme: settings.theme,
  });

  return (
    <ThemeProvider theme={theme}>
      <RTL direction={settings.direction}>
        <SnackbarProvider dense maxSnack={3}>
          <GlobalStyles />
          {auth.isInitialized ? content : <Login />}
        </SnackbarProvider>
      </RTL>
    </ThemeProvider>
  );
};

export default App;
